import { useMediaQuery } from "react-responsive";

export function useIsMobile(): boolean {
  return useMediaQuery({ maxWidth: 576 });
}
